<template>
  <div class="right">
    <Header></Header>
    <!-- <div class="mainTop">
        <div>
          当前位置：
          <router-link :to="{path:'/index'}" tag="span">首页</router-link>>
          <span @click="medical()">{{$route.query.dbcode == 2 ? '上市信息数据库' : '医药公司数据库'}}</span> >
          <span>{{$route.query.company}}</span>
        </div>
        <div></div>
    </div>-->
    <div class="mainTop">
      <div class="underHeader">
        <img src="../../assets/img/info.png" alt />
        当前位置：
      </div>
      <el-breadcrumb
        separator-class="el-icon-arrow-right"
        style="width:50%;height: 54px;display: inline-block;line-height: 54px;"
      >
        <el-breadcrumb-item :to="{ path: '/' }">平台首页</el-breadcrumb-item>
        <el-breadcrumb-item>{{$route.query.company}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <!-- <div class="rightCenter">
      <div class="centerTit"></div>
      <div @click="downloadFn(0)" class="centerCon">
        <div class="excel" style="cursor: pointer;">
          <img src="@/assets/img/Excel.png" alt />
          下载数据到Excel
        </div>
      </div>
    </div>-->
    <div class="rightBottom">
      <!-- 第一套 -->
      <div class="tabulation">
        <div style="width:100%;overflow: hidden;margin-bottom:11px;">
          <div
            style="display: inline-block;float:left;font-size:14px;font-weight:400;height: 32px;vertical-align: middle;line-height: 32px;color: #DFECF7;"
          >个人简介</div>
        </div>
        <!-- <table class="mailTable">
          <el-table :data="tableData1" border size="mini" style="width: 100%">
            <el-table-column prop="userName" label="姓名"></el-table-column>
            <el-table-column prop="duty" label="职务"></el-table-column>
            <el-table-column prop="startDate" label="起始时间"></el-table-column>
            <el-table-column prop="endDate" label="终止时间"></el-table-column>
          </el-table>
        </table>-->
        <table class="mailTable" cellspacing="0">
          <tr class="column">
            <td width="100">姓名</td>
            <td width="80">性别</td>
            <td width="100">出生日期</td>
            <td width="100">学历</td>
            <td width="100">国籍</td>
          </tr>
          <tr>
            <td>{{tableData1.personName}}</td>
            <td>{{tableData1.sex}}</td>
            <td>{{tableData1.birthday}}</td>
            <td>{{tableData1.education}}</td>
            <td>{{tableData1.nationality}}</td>
          </tr>

          <tr>
            <td style="color: #DFECF7;">个人简历</td>
            <td
              colspan="4"
              rowspan="0"
              style="line-height:2;padding:10px;"
            >{{tableData1.resume ? tableData1.resume.trim() : ''}}</td>
          </tr>
        </table>
      </div>
      <!-- 第二套 -->
      <div class="tabulation" style="margin-top:41px;">
        <div style="width:100%;overflow: hidden;margin-bottom:11px;">
          <!-- <el-select @change="SelectTimeFn2" v-model="searchData2.value" size="small" placeholder="请选择" style="width:165px;float:right;">
            <el-option
              v-for="item in searchData2.select"
              :key="item"
              :label="item"
              :value="item">
            </el-option>
          </el-select>-->
          <div
            style="display: inline-block;float:left;font-size:14px;font-weight:400;height: 32px;vertical-align: middle;line-height: 32px;color: #DFECF7;"
          >持股情况</div>
        </div>
        <el-table
          :data="tableData2"
          border
          size="mini"
          style="width: 100%"
          :header-cell-style="cellStyle"
        >
          <el-table-column prop="companyFullName" label="公司名称"></el-table-column>
          <el-table-column prop="shareType" label="股份类型"></el-table-column>
          <el-table-column prop="shareNumber" label="持股数量"></el-table-column>
          <el-table-column prop="shareChagneReason" label="持股变动原因"></el-table-column>
          <el-table-column prop="closingDate" label="截止日期"></el-table-column>
        </el-table>
      </div>
      <!-- 第三套 -->
      <div class="tabulation" style="margin-top:41px;">
        <div style="width:100%;overflow: hidden;margin-bottom:11px;">
          <!-- <el-select @change="SelectTimeFn3" v-model="searchData3.value" size="small" placeholder="请选择" style="width:165px;float:right;">
            <el-option
              v-for="item in searchData3.select"
              :key="item"
              :label="item"
              :value="item">
            </el-option>
          </el-select>-->
          <div
            style="display: inline-block;float:left;font-size:14px;font-weight:400;height: 32px;vertical-align: middle;line-height: 32px;color: #DFECF7;"
          >任职情况</div>
        </div>

        <el-table
          :data="tableData3"
          border
          size="mini"
          style="width: 100%"
          :header-cell-style="cellStyle"
        >
          <el-table-column prop="companyName" label="公司名称"></el-table-column>
          <el-table-column prop="duty" label="职务"></el-table-column>
          <el-table-column prop="startDate" label="任职日期"></el-table-column>
          <el-table-column prop="endDate" label="离职日期"></el-table-column>
          <el-table-column prop="remuneration" label="报酬(元)"></el-table-column>
        </el-table>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>
<script>
import api from "@/../static/common/api/api.js";
import magic from "@/../static/common/magic.js";
import rightTop from "@/components/rightTop";
import Header from "@/components/header";
import Footer from "@/components/footer";
import $ from "jquery";
export default {
  data() {
    return {
      tableData1: [],
      tableData2: [],
      tableData3: [],
      //选择数据
      searchData1: {
        select: [], //下拉框选项数据
        value: ""
      },
      searchData2: {
        select: [], //下拉框选项数据
        value: ""
      },
      searchData3: {
        select: [], //下拉框选项数据
        value: ""
      },
      companyList: [],
      paramsData: {} //URL参数集合
    };
  },
  components: {
    rightTop,
    Header,
    Footer
  },
  methods: {
    cellStyle(row, column, rowIndex, columnIndex) {
      return "color: #DFECF7;font-weight:bold;font-family:Microsoft YaHei;background:#F7F7F7;";
    },
    medical() {
      if (this.$route.query.dbcode == 2) {
        this.$router.push({
          path: "/search",
          query: {
            companyName: "",
            dbcode: 2,
            pageNo: 1,
            pageSize: 10
          }
        });
      }
      if (this.$route.query.dbcode == 1) {
        this.$router.push({
          path: "/search",
          query: {
            companyName: "",
            dbcode: 1,
            pageNo: 1,
            pageSize: 10
          }
        });
      }
    },
    //下载函数
    downloadFn(incomeType) {
      let _this = this;
      this.download(
        window.baseUrl +
          "/companyBasic/downExecutivesData?stockCode=" +
          this.paramsData.stockCode +
          "&enterpriseCode=" +
          this.paramsData.enterpriseCode +
          "&sessionDNum=" +
          this.searchData2.value.substring(1, 2) +
          "&sessionJNum=" +
          this.searchData3.value.substring(1, 2)
      );
    },
    download(url) {
      let a = document.createElement("a");
      a.href = url;
      let _id = Math.random() + Math.random();
      a.id = _id;
      a.click();
      window.URL.revokeObjectURL(url);
    },
    //第一个下拉框
    SelectTimeFn1(val) {
      console.log(val, "val");
      this.fetchTable1(
        this.paramsData.stockCode,
        this.paramsData.enterpriseCode,
        "1",
        val.substring(1, 2)
      ); //按产品
    },
    SelectTimeFn2(val) {
      console.log(val, "val");
      this.fetchTable2(
        this.paramsData.stockCode,
        this.paramsData.enterpriseCode,
        "2",
        val.substring(1, 2)
      ); //按行业
    },
    SelectTimeFn3(val) {
      console.log(val, "val");
      this.fetchTable3(
        this.paramsData.stockCode,
        this.paramsData.enterpriseCode,
        "3",
        val.substring(1, 2)
      ); //按地域
    },
    action() {
      // incomeType=收入类型分类 0:按产品 1:按行业 2:按地域
      //   this.fetchTimes();//获取所有时间的选项
      setTimeout(() => {
        this.fetchTable1(
          this.paramsData.stockCode,
          this.paramsData.enterpriseCode,
          this.paramsData.persionCode
        ); //按产品
        // this.fetchTable2(this.paramsData.stockCode,this.paramsData.enterpriseCode,'2',this.searchData2.value.substring(1,2));//按行业
        // this.fetchTable3(this.paramsData.stockCode,this.paramsData.enterpriseCode,'3',this.searchData3.value.substring(1,2));//按地域
        // $('.el-table thead tr th').css({'background':'#F7F7F7','color':'#333','font-size':'14px','font-weight':'400'});
      }, 900);
    },
    //获取所有时间的选项
    fetchTimes() {
      let _this = this;
      api
        .baseInfoTableTwoTime(
          this.paramsData.stockCode,
          this.paramsData.enterpriseCode,
          "2"
        )
        .then(res => {
          let data = res.data;
          let tmpArr = [];
          if (data.length == 0) {
            return;
          }
          for (let i = 0; i < data.length; i++) {
            tmpArr.push("第" + data[i] + "届");
          }
          _this.searchData2.select = tmpArr;
          _this.searchData2.value = tmpArr[0];
        });
      api
        .baseInfoTableTwoTime(
          this.paramsData.stockCode,
          this.paramsData.enterpriseCode,
          "3"
        )
        .then(res => {
          let data = res.data;
          let tmpArr = [];
          if (data.length == 0) {
            return;
          }
          for (let i = 0; i < data.length; i++) {
            tmpArr.push("第" + data[i] + "届");
          }
          _this.searchData3.select = tmpArr;
          _this.searchData3.value = tmpArr[0];
        });
    },
    fetchTable1(stockCode, enterpriseCode, persionCode) {
      let _this = this;
      api.getPersonInfoFn(stockCode, enterpriseCode, persionCode).then(res => {
        let data = res.data;
        console.log(data, "data1");
        _this.tableData1 = data.jianjie;
        _this.tableData2 = data.chigu;
        _this.tableData3 = data.renzhi;
      });
    },
    fetchTable2(stockCode, enterpriseCode, executivesType, sessionNum) {
      let _this = this;
      api
        .baseInfoTableTwo(stockCode, enterpriseCode, executivesType, sessionNum)
        .then(res => {
          let data = res.data;
          console.log(data, "data2");
          _this.tableData2 = data;
        });
    },
    fetchTable3(stockCode, enterpriseCode, executivesType, sessionNum) {
      let _this = this;
      api
        .baseInfoTableTwo(stockCode, enterpriseCode, executivesType, sessionNum)
        .then(res => {
          let data = res.data;
          console.log(data, "data3");
          _this.tableData3 = data;
        });
    }
  },
  mounted() {
    this.paramsData.stockCode = this.$route.query.stockCode;
    this.paramsData.enterpriseCode = this.$route.query.enterpriseCode;
    this.paramsData.persionCode = this.$route.query.persionCode;

    this.action(); //获取表格数据
  }
};
</script>
<style scoped lang="less">
#app{
  height: 100% !important;
}
.right {
  width:100%;
  height: 100%;
  //   margin-right: 23px;
  display: flex;
  flex-direction: column;
  background: url("../../assets/img/bg.png") no-repeat top;
  
  .rightTop {
    width: auto;
    height: auto;
    margin-right: 20px;
    background: #ffffff;
    border-radius: 2px;
    display: flex;
    flex-direction: column;
    padding: 0 20px 10px;
   
    .title {
      height: 50px;
      line-height: 50px;
      border-bottom: 1px solid #dfdfdf;
      display: flex;
      justify-content: space-between;
      align-items: center;
      span {
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #333;
      }
      .button {
        width: 88px;
        height: 30px;
        line-height: 30px;
        text-align: center;
        background: #3583ed;
        border-radius: 2px;
        color: #fefefe;
        font-size: 12px;
        font-family: Microsoft YaHei;
        font-weight: 400;
      }
    }
    .con {
      width: auto;
      flex: 1;
      font-size: 14px;
      font-family: Microsoft YaHei;
      color: #404040;
      display: flex;
      flex-direction: column;
      p {
        padding-top: 10px;
      }
    }
  }
  .rightCenter {
    width: auto;
    height: 61px;
    line-height: 61px;
    margin-right: 20px;
    padding: 0 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .centerTit {
      font-size: 16px;
      font-family: Microsoft YaHei;
      font-weight: bold;
    }
    .centerCon {
      width: auto;
      height: 61px;
      line-height: 61px;
      display: flex;
      .no {
        span {
          display: inline-block;
          font-size: 14px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #333;
        }
      }
      .excel {
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #3583ed;
        img {
          display: inline-block;
          width: 18px;
          height: 18px;
          transform: translate(0, 20%);
        }
      }
    }
  }
  .rightBottom {
    width: auto;
    height: 100%;
    flex:1;
    // margin-right: 20px;
    margin-bottom: 40px;
    padding: 20px 20px 50px 20px;
    .tabulation {
      width: 100%;
      height: auto;
      // background: lightblue;
    }
  }
}
@import "../../assets/less/style.less";
.mailTable,
.mailTable tr,
.mailTable tr td {
  border: 1px solid #dfdfdf;
}
.mailTable {
  font-size: 14px;
  color: #4b4b4b;
  width: 100%;
  font-family: Microsoft YaHei;
}
.mailTable tr td {
  height: 35px;
  line-height: 35px;
  box-sizing: border-box;
  padding: 0 10px;
  border: 1px solid #08396a !important;
}
.mailTable .column {
  background: #375572;
  color: #dfecf7;
  font-size: 14px;
  font-weight: bold;
  width: 20%;
}
.el-table thead {
  background: rgba(5, 43, 79, 0.8) !important;
  color: #dfecf7 !important;
  font-size: 14px !important;
  font-weight: bold !important;
}
.mainTop {
  display: flex;
  .underHeader {
    display: inline-block;
    height: 54px;
    line-height: 54px;
    padding-left: 19px;
    font-size: 14px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #dfecf7;
    img {
      width: 12px;
      height: 16px;
    }
  }
  /deep/ .el-breadcrumb__inner {
    font-size: 14px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #dfecf7;
  }
  /deep/ .el-breadcrumb__inner:hover {
    color: #dfecf7;
  }
}
</style>


// WEBPACK FOOTER //
// src/view/companyBaseInfo/personinfo.vue